import { render, staticRenderFns } from "./CustomDropDown.vue?vue&type=template&id=58815133&scoped=true"
import script from "./CustomDropDown.vue?vue&type=script&lang=js"
export * from "./CustomDropDown.vue?vue&type=script&lang=js"
import style0 from "./CustomDropDown.vue?vue&type=style&index=0&id=58815133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58815133",
  null
  
)

export default component.exports